/** Padre `repositorio`: no es un switch; se deriva de sus secciones. */

export const REPOSITORIO_PARENT_MODULE_ID = 'repositorio'

export function isRepositorioParentModuleId(moduleId) {
  return moduleId === REPOSITORIO_PARENT_MODULE_ID
}

export function withoutRepositorioParentPermission(permissions) {
  if (!Array.isArray(permissions)) return []
  return permissions.filter((p) => p?.moduleId !== REPOSITORIO_PARENT_MODULE_ID)
}
